import FormConfig from "../formConfig.js";
import {
  fun_PostAction,
  fun_GetAction,
  fun_Download,
  fun_UploadImg
} from "@/api/index";
import CaLock from "@/components/common/calock";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
import Pictureinfor from "../../../components/pictureinfor/index.vue";

export default {
  data() {
    return {
      // 判断是否从工作台进入
      workbenchMenu: null,
      // 工作台状态
      workbenchState: true,
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 表单绑定值
      form: {
        id: null, // 主键
        constructionNo: null, // 报建编号
        prjName: null, // 项目名称
        prjbuildCorpName: null, // 项目报建单位名称
        buildCorpNameCode: null, // 项目报建单位社会信用代码
        tenderLinkMan: null, // 招标联系人
        tenderLinkPhone: null, // 招标联系人电话
        agencyLinkMan: null, // 招标代理联系人
        agencyLinkPhone: null, // 招标代理电话
        agencyCorpName: null, // 招标代理机构名称
        agencyCorpCode: null, // 招标代理机构社会信用代码
        agencyCorpLegalPerson: null, // 代理机构法人姓名
        agencyCorpLegalPersonTel: null, // 代理机构法人办公电话
        agencyCorpTechMan: null, // 代理机构技术负责人姓名
        agencyCorpTechManTel: null, // 代理机构技术负责人办公电话
        agencyCorpAddress: null, // 代理机构注册地址
        agencyProjectAddress: null, // 代理项目地址
        agencyMark: null, // 代理内容
        prjManName: null, // 项目负责人姓名
        prjManDuty: null, // 项目负责人职务
        prjManTitle: null, // 项目负责人职称
        qualificationCertificateNum: null, // 执业资格证书及编号
        regulators: null, // 行政监督部门
        stateName: null, // 状态名称
        state: null, // 状态
        digitalSignature: null // 数字签名
      },
      // 全局加载
      fullLoading: null,
      // 主键
      id: null,
      // 操作类型
      controllerFlg: null,
      // 用于判断状态图片
      flagState: null,
      // 表头按钮
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "circle-plus-outline"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 其他专职人员绑定数据
      formObj: {
        // 表格数据
        tableData: []
      },
      // 勾选的数据
      multipleSelection: [],
      // 其他专职人员列表加载
      loading: false,
      // 其他专职人员列表绑定验证规则
      rules: {
        personName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }
        ],
        duty: [
          {
            required: true,
            message: "请输入职务",
            trigger: "blur"
          }
        ]
      }
    };
  },

  // 注册组件
  components: {
    CaLock, // CA锁
    AuditHistoryRecord, // 核验记录
    Pictureinfor // 附件上传
  },
  // 接收来自父组件的数据
  props: {
    // 用于判断是否为子组件
    isComponent: {
      type: Boolean,
      default: false
    }
  },
  // 模板编译前
  created() {
    // 获取数据
    this.workbenchMenu = sessionStorage.getItem("workbenchMenu")
      ? sessionStorage.getItem("workbenchMenu")
      : null;
  },
  // 模板编译完成
  mounted() {
    // 判断是否为子组件
    if (!this.isComponent) {
      // 获取主键
      this.id = this.$route.query.id;
      // 获取操作标识
      this.controllerFlg = this.$route.query.controllerFlg;
      // 获取详情
      this.fun_Details();
    }
  },
  // 自定义方法
  methods: {
    /**
     * 获取CA办理资料详情
     * @author shuhua
     */
    fun_Details() {
      // 调用页面样式
      this.fun_PageStyle();
      // 发起请求
      fun_GetAction("/agencyCorpRecords/detail", {
        id: this.id
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.form = data.model;
          // 如果主键为空
          if (this.id == "" || this.id == null) {
            // 设置主键
            this.id = data.model.id;
          }
          // 获取状态用于判断显示图片
          this.flagState = data.model.state;
          // 工作台状态
          this.workbenchState = data.workbenchState;
          // 获取其他专职人员一览
          this.fun_GetList();
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 页面样式
     */
    fun_PageStyle() {
      // 操作类型为查看详情
      if (this.controllerFlg == "detail") {
        // 遍历
        this.formConfigList.map((value, index) => {
          // 遍历标签页内表单
          value.formConfigList.map(form => {
            // 置灰
            form.disabled = true;
          });
        });
        // 隐藏其他专职人员操作按钮
        this.btnList = [];
      }
    },
    /**
     * 其他专职人员一览
     * @author shuhua
     */
    fun_GetList() {
      // 发起请求
      fun_PostAction("/agencyFulltimePerson/list", {
        agencyCorpRecordsId: this.form.id
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 表格数据
          this.formObj.tableData = data;
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 调用添加方法
          var newValue = {
            foreignCorpName: null,
            regPrin: null,
            percentTage: null,
            foreignIvestor: null,
            principalUnitNum: null,
            chineseName: null,
            nationNum: null
          };
          //添加新的行数
          this.formObj.tableData.push(newValue);
          break;
        default:
          // 遍历
          this.multipleSelection.map((value, index) => {
            // 遍历
            this.formObj.tableData.map((v, i) => {
              // 匹配已选中的
              if (value.index === v.index) {
                // 删除勾选的数据
                this.formObj.tableData.splice(i, 1);
              }
            });
          });
          // 清除选中数据
          this.$refs.multipleTable.clearSelection();
      }
    },
    /**
     * 列表添加class
     */
    addClass(row, column, rowIndex, columnIndex) {
      // 判断是序号
      if (row.column.type === "index") {
        return "index";
      }
    },
    /**
     * 添加时执行的方法
     * @author shuhua
     */
    tableRowClassName(row, rowIndex) {
      // 给每一行新增一个下标
      row.row.index = row.rowIndex;
    },
    /**
     * 其他专职人员列表勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值勾选数组
      this.multipleSelection = e;
    },
    /**
     * 下拉框选择事件
     * @author shuhu
     */
    fun_GetSelectVal(e, i) {
      // 下拉框赋值
      this.form[i] = e;
    },
    /**
     * 打开上传附件弹窗
     * @author shuhua
     */
    fun_OpenUpload() {
      // 打开弹窗
      this.$refs.pictureinfor.dialogVisible = true;
      // 打开弹框时调用
      this.$refs.pictureinfor.fun_GetOpen();
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 确定的方法
     * @author shuhua
     */
    fun_Confirm(state) {
      // 设置状态
      this.form.state = state;
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 外商投资列表验证
        this.$refs.ruleForm.validate(listValid => {
          // 验证通过
          if (valid && listValid) {
            // 其他专职人员信息为空
            if (this.formObj.tableData.length === 0) {
              // 弹出错误提示
              this.$alert(
                "专职人员姓名和职称为必填项，请至少保留一条正确的数据!",
                "warning"
              );
              return;
            }
            // 如果是通过
            if (state == "tj") {
              // 开启弹窗
              this.$refs.caLock.dialogCalock = true;
              // 签名数据, 交易人名称和日期
              this.$refs.caLock.data =
                this.form.prjbuildCorpName +
                this.form.buildCorpNameCode +
                this.form.agencyCorpName +
                this.form.agencyCorpCode;
              // 状态
              this.$refs.caLock.state = state;
            }
            // 如果是保存
            else {
              // 提交方法
              this.fun_Submit();
            }
          } else {
            return false;
          }
        });
      });
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.form.lockNo = lockNo;
      // 赋值数字签名
      this.form.digitalSignature = digitalSignature;
      // 提交的方法
      this.fun_Submit();
    },
    /**
     * 提交的方法
     * @author shuhua
     */
    fun_Submit() {
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("agencyCorpRecords/update", {
        ...this.form,
        list: JSON.stringify(this.formObj.tableData),
        id: this.id
      })
        .then(res => {
          // 解构res.data
          const { result, msg, data } = res.data;
          // 加载框取消
          this.fullLoading.close();
          // 操作成功
          if (result) {
            // 操作成功
            this.$message.success(msg);
            // 返回一览
            this.$router.back();
          } else {
            // 错误消息提示
            this.$message.error(msg);
          }
        })
        .catch(() => {
          // 加载框取消
          this.fullLoading.close();
        });
    },
    /**
     * 全局加载
     * @author liutong
     */
    fun_Loading(val) {
      this.fullLoading = this.$loading({
        lock: true,
        text: val ? val : "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 打开招标项目选择弹窗
     * @author shuhua
     */
    fun_OpenProjectDialog() {
      // 打开弹窗
      this.$refs.biddingProjectDialog.dialogVisible = true;
      // 请求接口
      this.$refs.biddingProjectDialog.fun_GetList();
    },
    /**
     * 打开代理机构选择弹窗
     * @author shuhua
     */
    fun_OpenAgencyDialog() {
      // 打开弹窗
      this.$refs.biddingAgencyDialog.dialogVisible = true;
      // 请求接口
      this.$refs.biddingAgencyDialog.fun_GetList();
    },
    /**
     * 清空
     * @author shuhua
     */
    fun_Clean(e) {
      // 招标项目信息清空
      if (e === "0") {
        // 清空报建编号
        this.form.constructionNo = null;
        // 清空项目名称
        this.form.prjName = null;
      } else {
        // 清空招标代理机构名称
        this.form.agencyCorpName = null;
        // 招标代理机构社会信用代码
        this.form.agencyCorpCode = null;
        // 代理机构法人姓名
        this.form.agencyCorpLegalPerson = null;
      }
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    }
  }
};
